import { render, staticRenderFns } from "./courseEvaluation.vue?vue&type=template&id=1a06e1ff&scoped=true"
import script from "./courseEvaluation.vue?vue&type=script&lang=js"
export * from "./courseEvaluation.vue?vue&type=script&lang=js"
import style0 from "./courseEvaluation.vue?vue&type=style&index=0&id=1a06e1ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a06e1ff",
  null
  
)

export default component.exports